// PdfDownload — receives a small base64 PDF from LiveView and downloads it via
// Blob. Used by guest-safe Discovery presentation exports.
export default {
  mounted() {
    this.handleEvent("pdf:download", ({ filename, base64 }) => {
      if (typeof base64 !== "string" || base64.length === 0) return

      const safeName =
        typeof filename === "string" && filename.trim() !== ""
          ? filename
          : "apresentacao.pdf"

      try {
        const bytes = atob(base64)
        const buffer = new Uint8Array(bytes.length)

        for (let i = 0; i < bytes.length; i += 1) {
          buffer[i] = bytes.charCodeAt(i)
        }

        const blob = new Blob([buffer], { type: "application/pdf" })
        const url = URL.createObjectURL(blob)
        const link = document.createElement("a")

        link.href = url
        link.download = safeName
        link.target = "_blank"
        link.style.display = "none"
        document.body.appendChild(link)
        link.click()
        link.remove()

        if (typeof link.download === "undefined") {
          window.open(url, "_blank", "noopener")
        }

        setTimeout(() => URL.revokeObjectURL(url), 30_000)
      } catch (_error) {
        // The server-side flash already reports export failures. If decoding
        // fails, fail silently instead of disrupting the LiveView.
      }
    })
  },
}
